import Vue from "vue";
import Vuex from "vuex";

import modules from "./modules";
import storage from "./storage";
import { abilityPlugin, ability as appAbility } from "./ability";
Vue.use(Vuex);
export const ability = appAbility;
const store = new Vuex.Store({
  state: {
    connected: false,
    error: "",
    message: "",
    packageVersion: process.env.PACKAGE_VERSION || "0",
    accessToken: "",
    permissions: [],
    authenticating: false,
    authenticationErrorCode: 0,
    authenticationError: "",
    refreshTokenPromise: null, // Holds the promise of the refresh token
    UserInfo: {},
    rules: [],
    selectedProductList : [],
    reportAuction:{},
    reportShop:{},
    reportEtender:{},
    ReportAuctionInfoByProviderPlatformAuction:{},
    AuctionInfoByProviderPlatformShop:{},
    AuctionInfoByProviderPlatformEtender:{},
    AuctionInfoByBuyerPlatfromAuction:{},
    AuctionInfoByBuyerPlatfromShop:{},
    AuctionInfoByBuyerPlatfromEtender:{},
    TopMaxLotCountAuctionInfoByProviderPlatformAuction:{},
    TopMaxLotCountAuctionInfoByProviderPlatformShop:{},
    TopMaxLotCountAuctionInfoByProviderPlatformEtender:{},
    TopMaxTotalCostAuctionInfoByProviderPlatformAuction:{},
    TopMaxTotalCostAuctionInfoByProviderPlatformShop:{},
    TopMaxTotalCostAuctionInfoByProviderPlatformEtender:{},
    AllUzexLot:{},
    AuctionInfoByStatusAuction:{},
  },
  plugins: [
    storage({
      storedKeys: ["rules"],
      destroyOn: ["logoutSuccess"],
    }),
    abilityPlugin,
  ],
  getters: {
    loggedIn: (state) => {
      return state.accessToken ? true : false;
    },

    authenticationErrorCode: (state) => {
      return state.authenticationErrorCode;
    },

    authenticationError: (state) => {
      return state.authenticationError;
    },

    authenticating: (state) => {
      return state.authenticating;
    },
  },
  actions: {
    async SignIn({ commit }, data) {
      try {
        commit("loginSuccess", data);
        router.push("/");
        return true;
      } catch (e) {
        e.message;
        if (e instanceof AuthenticationError) {
          commit("loginError", {
            errorCode: e.errorCode,
            errorMessage: e.message,
          });
        }

        return false;
      }
    },
    //   setOrganizationtype({ commit }, data) {
    //     commit("organizationtype", data);
    //   },
    logout({ commit }) {
      UserService.logout();
      commit("logoutSuccess");
      router.push("/user/login");
    },
    login({ commit }, data) {
      commit("loginSuccess", data);
    },
  },
  mutations: {
    loginRequest(state) {
      state.authenticating = true;
      state.authenticationError = "";
      state.authenticationErrorCode = 0;
    },
    setUserInfo(state, data) {
      state.UserInfo = data;
    },

    loginSuccess(state, data) {
      state.accessToken = data.token;
      state.permissions = data.userinfo.Roles;
      let formattedRules = [];
      if (data.userinfo.Roles.length > 0) {
        formattedRules = data.userinfo.Roles.map((perm) => {
          let formattedObj = {};
          formattedObj.actions = perm;
          formattedObj.subject = "permissions";
          return formattedObj;
        });
      }
      state.rules = formattedRules;
      state.authenticating = false;
    },
    logoutSuccess(state) {
      state.accessToken = "";
      state.UserInfo = {};
    },
    // loginSuccess(state, data) {
    //   state.accessToken = data.token;
    //   state.permissions = data.userinfo.Roles;
    //   let formattedRules = [];
    //   if (data.userinfo.Roles.length > 0) {
    //     formattedRules = data.userinfo.Roles.map((perm) => {
    //       let formattedObj = {};
    //       formattedObj.actions = perm;
    //       formattedObj.subject = "permissions";
    //       return formattedObj;
    //     });
    //   }
    //   state.rules = formattedRules;
    //   state.authenticating = false;
    // },
    // logoutSuccess(state) {
    //   state.accessToken = "";
    //   state.UserInfo = {};
    // },
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== "production",
});

export default store;
